module.exports = __webpack_public_path__ + "img/chain_sale04.52520d3a.png";